import React, { useEffect, useState, useContext, Fragment } from "react";
import useAxiosPrivate from "../../../../../../Hooks/useAxiosPrivate";
import AlertContext from "../../../../../../context/AlertContext";
import constants from "../../../../../../constants";
import { isParentLogin } from "../../../../../../util";
import MenuSvgIcon from "../../../../../../Svg/MenuSvgIcon";
import TopicSvgIcon from "../../../../../../Svg/TopicSvgIcon";
import CircularProgress from "@mui/material/CircularProgress";
import { OACodingChallengSkeleton } from "./OACodingChallengSkeleton";

const SOACodingChallenge = () => {
  const { setShowNotify, setIsLoaded, navigate } = useContext(AlertContext);
  const axios = useAxiosPrivate();
  const [ccSections, setCcSections] = useState([]);
  const [ccTotals, setCCTotals] = useState([]);

  // console.log("ccdata", ccSections);
  // console.log("ccTotal", ccTotals);

  useEffect(() => {
    const fetchSections = async () => {
      setIsLoaded(true);
      try {
        let response = await axios.get(
          `node/learner/cc/section?isSOADashboard=${true}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          const ccData = response.data.data ?? [];
          ccData.map((section) => {
            section.complexity = JSON.parse(section.complexity || "[]");
            let totalCount = 0;
            let solvedCount = 0;
            section.complexity?.map((comp) => {
              totalCount += comp.totalCount;
              solvedCount += comp.solvedCount;
            });
            section.totalCount = totalCount;
            section.solvedCount = solvedCount;
          });
          setCcSections(response.data.data ?? []);
          setCCTotals(response.data.totals ?? []);
        } else {
          setShowNotify({
            show: true,
            title: "Error !",
            msg: "Something went wrong. Please try again later or contact gradious team.",
          });
        }
      } catch (error) {
        console.log(error);
        if (error.message.includes("403")) {
          setShowNotify({
            show: true,
            title: "Warning !",
            msg: "You have been logged-out due to inactivity. Login again.",
            isUnAuth: true,
          });
        } else {
          setShowNotify({
            show: true,
            title: "Error !",
            msg: error.message,
          });
        }
      } finally {
        setIsLoaded(false);
      }
    };
    fetchSections();
  }, [axios, setIsLoaded, setShowNotify]);

  if(!(ccSections?.length > 0 || ccTotals?.length > 0)){
    return(
      <OACodingChallengSkeleton/>
    )
  }
  return (
    <div className="SOACodingChallenge-Container">
        <>
          {" "}
          <div className="SOACoding-Header">Coding Challenges</div>
          <div className="SOACoding-Body">
            <div className="SOACodingBodyHead">
              <div className="SOACodingBodyHead-LeftSide">
                <MenuSvgIcon menuId={constants.MENU_ICON.CC} />
                <div className="SOACCTitle">All Coding Challenges</div>
              </div>
              <div className="SOACodingBodyHead-RightSide">
                {ccTotals.totalSolved ?? "-"}/{ccTotals.totalQuestions ?? "-"}
              </div>
            </div>
            <div className="SOACodingBodyContent">
              {ccSections.map((data) => (
                <Fragment key={data.id}>
                  <div
                    className="SOACodingContent"
                    style={{ cursor: !isParentLogin ? "pointer" : "default" }}
                    onClick={() => {
                      if (!isParentLogin) {
                        navigate(`/main/cc/section/${data.id}`);
                        sessionStorage.setItem("ccSecName", data.name);
                      }
                    }}
                  >
                    <div className="SOACodingBody-LeftSide">
                      <TopicSvgIcon icon={data.id} from="SOADashboard" />
                      <div className="SOACCTitle">{data.name}</div>
                    </div>
                    <div className="SOACodingBody-RightSide">
                      {data.solvedCount ?? "-"}/{data.totalCount ?? "-"}
                    </div>
                  </div>
                  <hr />
                </Fragment>
              ))}
              {/* {isLoaded 
          // && MANAGEMENTROLES.includes(getDataFromStorage("role")) 
          && (
            <Loading />
          )} */}
            </div>
          </div>
        </>
    </div>
  );
};

export default SOACodingChallenge;
